module.exports = __webpack_public_path__ + "static/media/badrangui.979f1849.png";